import { Badge } from "antd";
import styled from "styled-components";

export const StyledTaskStatus = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
`;

export const StyledBadge = styled(Badge)`
    .ant-badge-count {
        background: ${({ theme }) => theme.colors.primary};
    }
`;
